import React, { useMemo, useState } from "react";
import Stack from "@mui/material/Stack";
import Badge from "@mui/material/Badge";
import {
  AlertComponent,
  SearchInputComponent,
  SelectInputComponent,
} from "../../../../common/components";
import FilterIcon from "../../../../assets/icons/filter-icon.svg";
import { LeadFilterProps } from "./lead-filter.props";
import "./lead-filter.scss";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../../constants/routes";
import SplitButtonComponent from "../../../../common/components/split-button-component/split-button";
import { useResourcePermissions } from "../../../../common/hooks/resource-permissions";
import MODULES from "../../../../constants/modules";
import ImportModal from "../../../../common/components/import-modal/import-modal";
import { uploadFile } from "../../../../api/lead";
import { useSetLoading } from "../../../../common/hooks/appearance";
import Button from "../../../../common/components/button/button";

const LeadFilter: React.FC<LeadFilterProps> = (props: any) => {
  const {
    isOpenFilter,
    setIsOpenFilter,
    selectedLeadsFilter,
    onSearch,
    searchRef,
    resetSearch,
    isResetSearch,
    handleClickCreateNewForm,
    fetchLeads
  } = props;
  const { canRead, canWrite, canDelete } = useResourcePermissions(
    MODULES.LEAD_CAPTURE
  );
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [alertType, setAlertType] = useState<
    "error" | "success" | "info" | "warning"
  >("info");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const handleAlertClose = () => {
    setAlertOpen(false);
  };
  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);



  return (
    <div className="lead-capture-lead-list-search-filter-wrapper">
      <div className="lead-capture-lead-list-search-wrapper">
        <SearchInputComponent
          placeholder="Search by Lead name, Email, Lead owner etc."
          onSearch={onSearch}
          isReset={isResetSearch}
          ref={searchRef}
        />
      </div>
      <div className="lead-capture-lead-list-filter-wrapper">
        <div
          className="lead-capture-lead-list-icon-filter"
          onClick={() => setIsOpenFilter(!isOpenFilter)}
          tabIndex={0}
        >
          <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
            <Badge color="secondary"sx={{
              '& .MuiBadge-badge': {
                backgroundColor: '#887952',
              },
            }} badgeContent={selectedLeadsFilter}>
              <img src={FilterIcon} alt="Filter Icon" />
            </Badge>
          </Stack>
        </div>
        {canWrite && (
          <div className="lead-capture-lead-list-create-filter">
            <Button
            label="Create New Form"
            onClick={handleClickCreateNewForm}
            />
          </div>
        )}
      </div>
      <AlertComponent
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={handleAlertClose}
      />
    </div>
  );
};

export default LeadFilter;
